module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-4-m4.df05d378.jpg";